import { render } from "./InputsRenderer.vue?vue&type=template&id=ed375916&ts=true"
import script from "./InputsRenderer.vue?vue&type=script&lang=ts"
export * from "./InputsRenderer.vue?vue&type=script&lang=ts"

import "./InputsRenderer.vue?vue&type=style&index=0&id=ed375916&lang=css"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__